import * as React from 'react';

import classNames from 'classnames';

import type {CustomFieldEdgeFragment, EntityAttribute} from 'nutshell-graphql-types';

import type {FieldError} from '../../../../../../ui/core-entity/hooks/use-custom-field-handlers';

import {CustomFieldRow} from './custom-field-row';
import type {ClickToCallPropsType} from './custom-field-row';

import styles from './custom-field-list.module.css';

type Props = {
    customFields: CustomFieldEdgeFragment[];
    isWrapping?: boolean;
    handleTextFieldUpdate: (
        newValue: string | null | undefined,
        field: EntityAttribute
    ) => Promise<any>;
    handleEnumUpdate: (
        newValue: string[] | null | undefined,
        field: EntityAttribute
    ) => Promise<any>;
    handleCurrencyUpdate: (
        currencyShortname: string,
        value: number | null | undefined,
        field: EntityAttribute
    ) => Promise<any>;
    handleAddressUpdate: (
        address1: string,
        address2: string,
        address3: string,
        city: string,
        state: string,
        postalCode: string,
        country: string,
        field: EntityAttribute
    ) => Promise<any>;
    handlePhoneUpdate: (
        numberFormattedWithCountryCode: string,
        extension: string,
        field: EntityAttribute
    ) => Promise<any>;
    clickToCallProps: ClickToCallPropsType | null | undefined;
    fieldErrors: FieldError[];
    setErrorForField: (fieldError: FieldError) => void;
};

export function CustomFieldList(props: Props) {
    const getErrorMessageForField = (fieldName: string): string | null | undefined => {
        const fieldError = props.fieldErrors.find((error) => error.fieldName === fieldName);

        return fieldError ? fieldError.error : null;
    };

    const fieldCount = props.customFields.length;

    return (
        <div className={styles.container}>
            <div
                className={classNames({
                    [styles.column]: !props.isWrapping,
                    [styles['grid-1-column']]: props.isWrapping && fieldCount === 1,
                    [styles['grid-2-column']]: props.isWrapping && fieldCount === 2,
                    [styles.grid]: props.isWrapping && fieldCount > 2,
                })}
            >
                {props.customFields.map((customField) => (
                    <div key={customField.node.id}>
                        <CustomFieldRow
                            key={customField.node.id}
                            field={customField.node}
                            value={customField.value}
                            handleTextFieldUpdate={props.handleTextFieldUpdate}
                            handleEnumUpdate={props.handleEnumUpdate}
                            handleCurrencyUpdate={props.handleCurrencyUpdate}
                            handleAddressUpdate={props.handleAddressUpdate}
                            handlePhoneUpdate={props.handlePhoneUpdate}
                            clickToCallProps={props.clickToCallProps}
                            error={getErrorMessageForField(customField.node.attribute.name)}
                            setErrorForField={props.setErrorForField}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
